import ScheduleNode from "./ScheduleNode";
import HuntNode from "./HuntNode";
import AttendantNode from "./AttendantNode";
import AnnouncementNode from "./AnnouncementNode";
import VoicemailNode from "./VoicemailNode";
import UserExtensionNode from "./UserExtensionNode";
import ACDQueueNode from "./ACDQueueNode";
import CallerIDNode from "./CallerIDNode";
import EndCallNode from "./EndCallNode";
import ExternalNumberNode from "./ExternalNumberNode";
import ClosedAttendantNode from "./ClosedAttendantNode";
import HolidayAttendantNode from "./HolidayAttendantNode";
import Notes from "./Notes";
import LunaNode from "./LunaNode"
import DirectoryNode from "./DirectoryNode";
import OperatorNode from "./OperatorNode";
export const nodeTypes = {
  callerIdNode: CallerIDNode,
  scheduleNode: ScheduleNode,
  huntNode: HuntNode,
  attendantNode: AttendantNode,
  announcementNode: AnnouncementNode,
  voicemailNode: VoicemailNode,
  userExtensionNode: UserExtensionNode,
  acdQueueNode: ACDQueueNode,
  endCallNode: EndCallNode,
  externalNumberNode: ExternalNumberNode,
  closedAttendantNode: ClosedAttendantNode,
  holidayAttendantNode: HolidayAttendantNode,
  notes: Notes,
  lunaNode:LunaNode,
  directoryNode : DirectoryNode,
  operatorNode : OperatorNode
};
